var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg16 = function Svg16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.252 6.226a3.126 3.126 0 0 1 4.536 0q.19.196.34.416l.096.149.037.067a.75.75 0 0 1-1.317.714 1.8 1.8 0 0 0-.236-.307 1.627 1.627 0 0 0-2.374 0l-2.16 2.248a1.87 1.87 0 0 0 0 2.557 1.627 1.627 0 0 0 2.373 0l.477-.496.056-.053a.751.751 0 0 1 1.025 1.093l-.475.495a3.127 3.127 0 0 1-4.538 0 3.367 3.367 0 0 1 0-4.636z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.873 2.892a3.127 3.127 0 0 1 4.537 0 3.367 3.367 0 0 1 0 4.635l-2.16 2.248a3.124 3.124 0 0 1-4.537 0 3.3 3.3 0 0 1-.34-.417l-.095-.147-.037-.069a.75.75 0 0 1 1.316-.713q.1.163.238.307c.557.58 1.395.666 2.035.274q.18-.11.339-.274l2.159-2.248a1.87 1.87 0 0 0 0-2.557 1.627 1.627 0 0 0-2.374 0l-.476.496-.056.052a.75.75 0 0 1-1.025-1.092z"
  })));
};
export default Svg16;